import React from 'react';

interface FormInputProps extends React.InputHTMLAttributes<HTMLInputElement | HTMLTextAreaElement> {
  as?: 'input' | 'textarea';
}

const FormInput: React.FC<FormInputProps> = ({ as = 'input', className = '', ...props }) => {
  const baseClassName = "w-full p-2 border rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent";
  
  return as === 'textarea' ? (
    <textarea
      {...props as React.TextareaHTMLAttributes<HTMLTextAreaElement>}
      className={`${baseClassName} ${className}`}
    />
  ) : (
    <input
      {...props as React.InputHTMLAttributes<HTMLInputElement>}
      className={`${baseClassName} ${className}`}
    />
  );
};

export default FormInput;